import React, { Component } from "react";
import { Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";
import "./ErrorBoundary.css";
import { appTrace } from "../../services/appTrace";

export const withRouter = (WrapComponent) => (props) => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <WrapComponent navigate={navigate} location={location} {...props} />
    );
};

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            previousPathname: "",
        };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.location.pathname !== state.previousPathname) {
            return { hasError: false, previousPathname: props.location.pathname };
        }
        return state;
    }

    componentDidCatch(error, errorInfo) {
        appTrace.error(error, {
            source: "ErrorBoundary",
            componentStack: errorInfo.componentStack,
        });
        console.log(error, errorInfo);
    }

    render() {
        const { children, t } = this.props;
        const { hasError } = this.state;
        if (hasError) {
            return (
                <div className="ErrorBoundary">
                    <Typography variant="h1">{t("errorPage.oops")}</Typography>
                    <Typography variant="h3">{t("errorPage.title")}</Typography>
                </div>
            );
        }

        return children;
    }
}

export default withRouter(withTranslation()(ErrorBoundary));
